module.exports = "<router-outlet appToast></router-outlet>\n"